var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.publisher,
        title: _vm.$t("PAUSE_AFFILIATE_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("PAUSE_AFFILIATE_MODAL_CANCEL_ACTION"),
        "confirm-action-text": _vm.$t("PAUSE_AFFILIATE_MODAL_CONFIRM_ACTION"),
        "show-cancel-button": _vm.showActions,
        "show-confirm-button": _vm.showActions
      },
      on: { confirm: _vm.confirmPause, close: _vm.closePauseModal }
    },
    [
      _c("i18n", {
        attrs: { path: "PAUSE_AFFILIATE_MODAL_TEXT", tag: "p" },
        scopedSlots: _vm._u([
          {
            key: "affiliateName",
            fn: function() {
              return [_c("strong", [_vm._v(_vm._s(_vm.publisher.name))])]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }